import { FileQuestion, LayoutGrid, Tag, Star } from "lucide-react";

const metrics = [
  { icon: Tag, value: "5 %", label: "Rabatt mit LONGEVITY" },
  { icon: LayoutGrid, value: "4", label: "Produktkategorien" },
  { icon: FileQuestion, value: "13", label: "FAQ-Antworten" },
  { icon: Star, value: "4,76/5", label: "Trusted-Shops-Bewertung*" },
];

const TrustSection = () => (
  <section id="ueber-heilys" className="py-10 md:py-20">
    <div className="container">
      <div className="mx-auto max-w-3xl">
        <h2 className="text-center font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
          Was ist heilys? Marke, Hersteller &amp; unabhängige Einordnung
        </h2>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4 sm:gap-4 md:mt-8">
          {metrics.map((m) => (
            <div key={m.label} className="flex flex-col items-center rounded-xl border border-border/50 bg-card p-3 sm:p-4 text-center">
              <div className="inline-flex items-center justify-center rounded-lg bg-primary/10 p-2">
                <m.icon className="h-4 w-4 text-primary sm:h-5 sm:w-5" aria-hidden="true" />
              </div>
              <span className="mt-2 font-display text-lg font-bold text-foreground sm:text-xl">{m.value}</span>
              <span className="mt-0.5 text-[10px] leading-tight text-muted-foreground sm:text-xs">{m.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-4 sm:mt-6 space-y-3 sm:space-y-4 text-xs sm:text-sm leading-relaxed text-muted-foreground md:text-base">
          <p>
            <strong className="text-foreground">heilys</strong> ist eine deutsche Marke der weCare+ GmbH mit Sitz in Bielefeld und spezialisiert auf Rotlichttherapie-Geräte für den Heimgebrauch. Das Sortiment umfasst großflächige Panels, kompakte Lampen, flexible Wearables sowie das kompakte Gen30+Vision – alle Geräte arbeiten mit Wellenlängen zwischen 630 und 850 nm.
          </p>
          <p>
            Wer nach einem heilys Rabattcode oder einer Einordnung des Sortiments sucht, findet online oft entweder reine Couponseiten ohne Mehrwert oder den offiziellen Shop ohne unabhängige Orientierung. Genau hier setzt heilys.info an: Diese Seite bündelt den aktuellen heilys Gutscheincode LONGEVITY an einem Ort und ordnet gleichzeitig die verschiedenen Produktkategorien rund um Rotlichttherapie für zuhause sachlich ein.
          </p>
          <p>
            heilys bietet eine Reihe von Produkten im Bereich Licht- und Rotlichtanwendungen, darunter großflächige Panels, kompakte Lampen und flexible Wearables. Diese Seite hilft dabei, die Kategorien besser zu verstehen und den passenden Einstieg zu finden. Dabei ist heilys.info eine unabhängige Informationsseite und steht in keiner direkten Verbindung zum Hersteller.
          </p>
          <p className="text-[10px] text-muted-foreground sm:text-xs">
            *Bewertung laut Trusted Shops zum Zeitpunkt der letzten Recherche. Aktuelle Bewertungen können abweichen.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default TrustSection;
